$animation-duration: 1s;

sew-ws-tile-gallery {
    &:not([no-grid]) {
        @include grid;
    }

    &:not([no-margin]):not(.no-headline) {
        margin-top: 100px;

        @include mq-2 {
            margin-top: 80px;
        }

        @include mq-1 {
            margin-top: 60px;
        }
    }

    &:not([no-margin]).no-headline {
        padding-top: 100px;

        @include mq-2 {
            padding-top: 80px;
        }

        @include mq-1 {
            padding-top: 60px;
        }
    }

    * {
        box-sizing: border-box;
    }

    --preview-height: 120px;
    --thumb-background: transparent;
    --thumb-background-hover: linear-gradient(45deg, #2e83ba, #246791);
    --thumb-icon: #246791;
    --link-color-hover: #{$color-red};

    &[theme='anthrazit'] {
        --thumb-background: transparent;
        --thumb-background-hover: #{$color-grey-01-dark};
        --thumb-icon: #{$color-grey-01-dark};
    }

    &[theme='red'] {
        --thumb-background: transparent;
        --thumb-background-hover: #{$color-red};
        --thumb-icon: #{$color-red};
    }

    &[theme='grey'] {
        --thumb-background: #{$color-grey-05-light};
        --thumb-background-hover: #{$color-grey-01-dark};
        --thumb-icon: #{$color-grey-01-dark};
    }

    h2 {
        @include typo-ws-h2;

        margin: 0;
    }

    p {
        @include typo-ws-paragraph;

        margin: 6px 0 0;
    }

    // has no real purpose, just to trigger animation ended event
    @keyframes animationEndedTrigger {
        to {
            zoom: 1;
        }
    }

    .item-wrapper {
        --tile-opacity: 1;

        position: relative;
        margin-top: 40px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        align-content: start;
        gap: var(--column-gap);
        overflow: hidden;
        height: var(--item-wrapper-height, auto);
        transition: height $animation-duration;

        &.content-open {
            height: calc(var(--content-height) + var(--preview-height) + 4px);
            animation: animationEndedTrigger $animation-duration;
        }

        &.open-ended {
            --tile-opacity: 0;

            transition: none;
        }
    }

    @include mq-2 {
        --preview-height: 100px;
    }

    @include mq-1 {
        --preview-height: 60px;

        .item-wrapper {
            grid-template-columns: 1fr 1fr;
        }
    }
}
